
export default {
  name: 'BaseNavigatorCompanyCard',
  props: {
    company: {
      type: Object,
      default: null,
    },
    topMessage: {
      type: String,
      default: null,
    },
    theme: {
      type: String,
      default: 'light',
    },
  },
  data() {
    return {
      streamsVisibleCount: 6,
    }
  },
  computed: {
    isHavButtons() {
      return (
        (this.company?.company?.actionButton &&
          this.company?.company?.actionButton?.status) ||
        this.company.statistics?.articles?.publishedCount +
          this.company.statistics?.telegram?.publishedCount >
          0 ||
        this.company.statistics.products?.publishedCount > 0 ||
        this.company.statistics.goods?.publishedCount > 0 ||
        this.company.statistics.vacancys?.publishedCount > 0 ||
        this.company.statistics.events?.publishedCount > 0
      )
    },
    isAccounter() {
      return (
        this.$auth.loggedIn &&
        this.$auth.user?.roles?.some((role) =>
          ['ADMIN', 'ACCOUNTER'].includes(role)
        )
      )
    },
    noArticleLastSevenDays() {
      const lastArticlePublishDate = this.company.statistics?.lastPublishArticle
        ?.publishDate
        ? new Date(
            this.company.statistics?.lastPublishArticle?.publishDate
          ).setHours(0, 0, 0, 0)
        : null
      const today = new Date()
      const sevenDayAgoDate = new Date(
        today.setDate(today.getDate() - 7)
      ).setHours(0, 0, 0, 0)

      return !lastArticlePublishDate || lastArticlePublishDate < sevenDayAgoDate
    },
    streams() {
      const filteredStreams = this.company?.statistics?.forStreams?.map(
        (stream) => {
          if ('_id' in stream && 'publishedCount' in stream && stream?._id) {
            return stream._id
          } else {
            return stream
          }
        }
      )
      return filteredStreams.slice(0, this.streamsVisibleCount)
    },
  },
  methods: {
    inView({ isInView }) {
      if (isInView) {
        this.setShow()
      }
    },
    setShow() {
      this.$axios.$post('/activity/show/author', {
        username: this.company.username,
      })
    },
  },
}
